import { isIOS, isMacOs, isSafari } from 'react-device-detect';

export const playbackDuration = 60; // 1 minute
export const maxDuration = 3 * 60 * 60; // 3 hours
export const AUDIO_BITS_PER_SECOND = 32000;
export const MIN_BLOB_BYTES = 500;
export const FINALIZE_WATCHDOG_MS = 30000;
const LONG_RECORDING_CHUNK_THRESHOLD = 60;

const createdObjectURLs = [];
let pauseCount = 0; // on each pause an extra chunk added to audioChunksRef

export const getPauseCount = () => pauseCount;
export const incrementPauseCount = () => {
  pauseCount += 1;
};
export const resetPauseCount = () => {
  pauseCount = 0;
};

export const formatTime = (numberOfSeconds) => {
  const date = new Date(0);
  date.setSeconds(numberOfSeconds);
  return date.toISOString().substring(11, 19);
};

export function timeout(delay) {
  return new Promise((res) => setTimeout(res, delay));
}

export const createSafeObjectURL = (blob) => {
  const url = URL.createObjectURL(blob);
  createdObjectURLs.push(url);
  return url;
};

export const revokeSafeObjectURL = (url) => {
  const index = createdObjectURLs.indexOf(url);
  if (index !== -1) {
    URL.revokeObjectURL(url);
    createdObjectURLs.splice(index, 1);
  }
};

export const revokeAllObjectURLs = () => {
  createdObjectURLs.forEach((url) => {
    try {
      URL.revokeObjectURL(url);
    } catch (e) {
      console.warn('Error revoking URL:', e);
    }
  });
  createdObjectURLs.length = 0;
};

export function buildFinalBlob(chunks, pluginBlob) {
  const isAppleRecording = isIOS || (isMacOs && isSafari);
  const defaultMime = isAppleRecording ? 'audio/mp4' : 'audio/webm';
  const chunkCount = chunks.length;
  // Only trust plugin blob from this finalize's record-end (ref cleared at processAudio start)
  const pluginOk = pluginBlob && pluginBlob.size > MIN_BLOB_BYTES;

  // Long sessions (all platforms): prefer plugin blob — avoid merging thousands of chunks
  if (pluginOk && chunkCount > LONG_RECORDING_CHUNK_THRESHOLD) {
    console.log('Using plugin blob (long recording):', pluginBlob.size, 'bytes,', chunkCount, 'chunks');
    return pluginBlob;
  }

  let chunkBlob = null;
  if (chunkCount > 0) {
    const mimeType = chunks[0]?.type || defaultMime;
    chunkBlob = new Blob(chunks, { type: mimeType });
  }

  const chunkOk = chunkBlob && chunkBlob.size > MIN_BLOB_BYTES;

  if (!pluginOk && !chunkOk) return null;

  // Safari/iOS (shorter recordings): chunk assembly is more reliable than plugin blob alone
  if (isAppleRecording) {
    if (chunkOk) {
      console.log('Using chunk blob (Apple):', chunkBlob.size, 'bytes from', chunkCount, 'chunks');
      return chunkBlob;
    }
    if (pluginOk) {
      console.warn('Using plugin blob fallback (Apple):', pluginBlob.size, 'bytes');
      return pluginBlob;
    }
    return null;
  }

  // Desktop: prefer plugin record-end blob when healthy (skips expensive chunk merge)
  if (pluginOk) {
    if (!chunkOk || pluginBlob.size >= chunkBlob.size * 0.9) {
      console.log('Using plugin blob:', pluginBlob.size, 'bytes');
      return pluginBlob;
    }
    console.warn('Plugin blob smaller than chunks, using chunk assembly:', pluginBlob.size, 'vs', chunkBlob.size);
    return chunkBlob;
  }

  console.log('Using chunk blob:', chunkBlob.size, 'bytes from', chunks.length, 'chunks');
  return chunkBlob;
}
